// AUROPI – 4x3 variants
const AUROPI_4X3_VARIANTS = {
  Clasico: 46316474007710,
  UnoDeCada: 46316538101918
};

function getEls() {
  return {
    optionsWrap: document.getElementById('auropi-options'),
    colorX1: document.getElementById('auropi-color-x1'),
    colorX2: document.getElementById('auropi-color-x2'),
    typeSelector: document.getElementById('auropi-pack-type-selector'),
    x2Error: document.getElementById('auropi-x2-error'),
    hiddenInput: document.getElementById('auropi-main-variant-id')
  };
}
function showForPack(pack) {
  function showForPack(pack) {
    // === AUROPI: normalizar pack ===
if (pack === '2') pack = 'x2';
if (pack === '1') pack = 'x1';
if (pack === '4' || pack === '4x3') pack = 'x4';

  const { optionsWrap } = getEls();
  if (!optionsWrap) return;

  // 1) mover #auropi-options al slot del pack elegido
  const slot = document.querySelector(`[data-auropi-slot="${pack}"]`);
  if (slot) {
    slot.appendChild(optionsWrap);
  }

  // 2) mostrar el contenedor ya “adentro”
  optionsWrap.style.display = 'block';

  // 3) ocultar / mostrar sub-bloques
  const x1 = document.getElementById('auropi-color-x1');
  const x2 = document.getElementById('auropi-color-x2');
  const x4 = document.getElementById('auropi-pack-type-selector');

  if (x1) x1.style.display = (pack === 'x1') ? 'block' : 'none';
  if (x2) x2.style.display = (pack === 'x2') ? 'block' : 'none';
  if (x4) x4.style.display = (pack === 'x4') ? 'block' : 'none';
}
  const { optionsWrap, colorX1, colorX2, typeSelector, x2Error } = getEls();
  // === AUROPI: reset + mover + mostrar (orden seguro) ===

// 1) resetear todo
if (optionsWrap) optionsWrap.style.display = 'none';
if (colorX1) colorX1.style.display = 'none';
if (colorX2) colorX2.style.display = 'none';
if (typeSelector) typeSelector.style.display = 'none';
if (x2Error) x2Error.style.display = 'none';

// 2) mover el contenedor al slot del pack activo
if (optionsWrap) {
  const slot = document.querySelector(`[data-auropi-slot="${pack}"]`);
  if (slot) {
    slot.appendChild(optionsWrap);
  }
}

// 3) mostrar SOLO lo correspondiente al pack
if (pack === 'x1' && colorX1) {
  colorX1.style.display = 'block';
}

if (pack === 'x2' && colorX2) {
  colorX2.style.display = 'block';
}

if (pack === 'x4' && typeSelector) {
  typeSelector.style.display = 'block';
}

// 4) mostrar wrapper final
if (optionsWrap) optionsWrap.style.display = 'block';
return;
}
// Escucha el selector ORIGINAL de Shrine (name="quantity")
// Defaults por pack (PONÉ LOS IDS REALES)
const AUROPI_DEFAULTS = {
  x1: 46316476301470,      // <-- CAMBIAR: Pack 1 color base (ej Negro)
  x2: 46316475842718,      // <-- CAMBIAR: Pack 2 color base (ej Negro)
  x4: AUROPI_4X3_VARIANTS.Clasico // o el ID de Clásico
};

document.addEventListener('change', function (e) {
  const input = e.target.closest('input[name="quantity"][data-auropi-pack]');
  if (!input) return;

  const pack = input.dataset.auropiPack; // x1 / x2 / x4
  showForPack(pack);
  const c1 = document.getElementById('auropi_prop_color_1');
const c2 = document.getElementById('auropi_prop_color_2');

if (c1) { c1.disabled = (pack !== 'x2'); if (pack !== 'x2') c1.value = ''; }
if (c2) { c2.disabled = (pack !== 'x2'); if (pack !== 'x2') c2.value = ''; }

  // ✅ Resetear siempre a un variant válido del pack (evita "se queda pegado")
  const { hiddenInput } = getEls();
  if (hiddenInput && AUROPI_DEFAULTS[pack]) {
    hiddenInput.value = AUROPI_DEFAULTS[pack];
    hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // ✅ Limpieza UI de selecciones visuales
  document.querySelectorAll('.auropi-type.is-active').forEach(b => b.classList.remove('is-active'));
});
// Click en botones del tipo 4x3
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.auropi-type');
  if (!btn) return;

  // ✅ UI selección
  document.querySelectorAll('.auropi-type').forEach(b => b.classList.remove('is-active'));
  btn.classList.add('is-active');

  const { hiddenInput } = getEls();
  if (!hiddenInput) return;

  const variantId = AUROPI_4X3_VARIANTS[btn.dataset.type];
  if (!variantId) return;

  hiddenInput.value = variantId;
  hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
});
// Ocultar bloque hasta que elijan pack
document.addEventListener('DOMContentLoaded', function () {
  const { optionsWrap } = getEls();
  if (optionsWrap) optionsWrap.style.display = 'none';
});
// ===== AUROPI PACK ENGINE =====

// 4x3 (ya los tenés)
const AUROPI_4X3 = {
  Clasico: 46316474007710,
  UnoDeCada: 46316538101918
};

// TODO: completar con tus variantes reales por color:
const AUROPI_COLORS_X1 = {
  Negro: null, Blanco: null, Arena: null, Cereza: null, Eclipse: null, Nieve: null
};
const AUROPI_COLORS_X2 = {
  Negro: null, Blanco: null, Arena: null, Cereza: null, Eclipse: null, Nieve: null
};

// Helpers
function setVariantId(id) {
  const input = document.getElementById('auropi-main-variant-id');
  if (!input || !id) return;
  input.value = id;
  input.dispatchEvent(new Event('change', { bubbles: true }));
}

// Mostrar/ocultar UI de opciones
function showOptionsFor(pack) {
  const wrap = document.getElementById('auropi-options');
  const colors = document.getElementById('auropi-color-selector');
  const types = document.getElementById('auropi-pack-type-selector');
  if (!wrap || !colors || !types) return;

  wrap.style.display = 'block';
  colors.style.display = (pack === 'x1' || pack === 'x2') ? 'block' : 'none';
  types.style.display  = (pack === 'x4') ? 'block' : 'none';
}

// Detectar pack seleccionado (los radios siguen estando en la página)
function getSelectedPack() {
  const checked = document.querySelector('input[name="quantity"][data-auropi-pack]:checked');
  return checked ? checked.dataset.auropiPack : null;
}

// Cuando elegís pack
document.addEventListener('change', (e) => {
  const input = e.target.closest('input[name="quantity"][data-auropi-pack]');
  if (!input) return;

  const pack = input.dataset.auropiPack;
  showOptionsFor(pack);

  // defaults seguros:
  if (pack === 'x4') setVariantId(AUROPI_4X3.Clasico);
});

// Tipo 4x3
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.auropi-type');
  if (!btn) return;

  const id = AUROPI_4X3[btn.dataset.type];
  setVariantId(id);
});

// Color x1/x2
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.auropi-color');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();
  if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

  const { hiddenInput, x2Error } = getEls();
  if (!hiddenInput) return;

  const selectedPack = document.querySelector('input[data-auropi-pack]:checked');
  const pack = selectedPack ? selectedPack.dataset.auropiPack : null;
  const which = btn.dataset.which; // "c1" o "c2"
const color = btn.dataset.color;

  // --- PACK X1: comportamiento normal (1 color) ---
  if (pack === 'x1') {
    // UI: activar solo dentro del grupo x1
    const row = btn.closest('.auropi-colors-x1');
    if (row) row.querySelectorAll('.auropi-color').forEach(b => b.classList.remove('is-active'));
    btn.classList.add('is-active');

    const vid = btn.dataset.variantX1;
    if (!vid) return;

    hiddenInput.value = vid;
    hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
    return;
  }

  // --- PACK X2: dos colores obligatorios ---
  if (pack === 'x2') {
    if (x2Error) x2Error.style.display = 'none';

    const which = btn.dataset.which; // c1 o c2
    const color = btn.dataset.color;
const legacy = document.getElementById('auropi_prop_color');
if (legacy) legacy.value = '';

    if (which === 'c1') {
      AUROPI_X2_COLOR_1 = color;
      const c1 = document.getElementById('auropi_prop_color_1');
if (c1) c1.value = color;

      // UI: activar solo en fila broche 1
      const row1 = btn.closest('.auropi-colors-x2-1');
      if (row1) row1.querySelectorAll('.auropi-color').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');

      // opcional: setear variant del pack x2 según color 1
      const vid = btn.dataset.variantX2;
      if (vid) {
        hiddenInput.value = vid;
        hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

if (which === 'c2') {
  AUROPI_X2_COLOR_2 = color;

  const c2 = document.getElementById('auropi_prop_color_2');
  if (c2) c2.value = color;

  // UI: activar solo en fila broche 2
  const row2 = btn.closest('.auropi-colors-x2-2');
  if (row2) row2.querySelectorAll('.auropi-color').forEach(b => b.classList.remove('is-active'));
  btn.classList.add('is-active');
}

  }
});
// ===============================
// AUROPI – SELECTOR DE COLORES (X1 / X2)
// ===============================
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.auropi-color');
  if (!btn) return;

  // Evitar que Shrine / labels interfieran
  e.preventDefault();
  e.stopPropagation();
  if (typeof e.stopImmediatePropagation === 'function') {
    e.stopImmediatePropagation();
  }

  const { hiddenInput } = getEls();
  if (!hiddenInput) return;

  const selectedPack = document.querySelector('input[data-auropi-pack]:checked');
  const pack = selectedPack ? selectedPack.dataset.auropiPack : null;

  // UI: marcar selección
  const row = btn.closest('.auropi-colors') || btn.parentElement;
  row.querySelectorAll('.auropi-color').forEach(b => b.classList.remove('is-active'));
  btn.classList.add('is-active');

  let variantId = null;
  let AUROPI_X2_COLOR_1 = null;
let AUROPI_X2_COLOR_2 = null;
  // PACK X1
  if (pack === 'x1') {
    variantId = btn.dataset.variantX1;
  }

  // PACK X2 (por ahora mismo color x2, después lo extendemos)
  if (pack === 'x2') {
    variantId = btn.dataset.variantX2;
  }

  if (!variantId) return;

  hiddenInput.value = variantId;
  hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
});
// === AUROPI: inicializar opciones en carga ===
document.addEventListener('DOMContentLoaded', function () {
  const checkedPack = document.querySelector('input[data-auropi-pack]:checked');
  if (checkedPack) {
    showForPack(checkedPack.dataset.auropiPack);
  }
});
